import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@sunrun/component-library';
import { Color } from '@sunrun/mui-theme';
import { Header } from '../general';
import { Background, ButtonContainer, Container, Content, SmallTextCentered, StyledBackground, TitleDiv } from './SharedElements';

const PageContentCard = ({
  backgroundImg,
  buttonText,
  cardHeader,
  customCardWidth,
  customAsterisk,
  dataTestId,
  enrollmentContent,
  onButtonClick,
  pageHeader,
  showSuccessPageView,
  successContent,
}) => {
  return (
    <StyledBackground>
      <Content data-testid={dataTestId}>
        {pageHeader && <Header data-testid="page-header" title={pageHeader} backgroundColor={Color.WHITE} showMainIconMobile color={Color.BLACK} />}
        <Container customCardWidth={customCardWidth}>
          {backgroundImg && <Background />}
          {!showSuccessPageView && (
            <>
              {cardHeader && <TitleDiv data-testid="card-header">{cardHeader}</TitleDiv>}
              {enrollmentContent && <div data-testid="enrollment-content">{enrollmentContent}</div>}
              {buttonText && onButtonClick && (
                <ButtonContainer>
                  <Button data-testid="button" primary onClick={onButtonClick}>
                    {buttonText}
                  </Button>
                </ButtonContainer>
              )}
              {customAsterisk && <SmallTextCentered data-testid="custom-asterisk">{customAsterisk}</SmallTextCentered>}
            </>
          )}
          {showSuccessPageView && <div data-testid="success-content">{successContent}</div>}
        </Container>
      </Content>
    </StyledBackground>
  );
};

PageContentCard.propTypes = {
  backgroundImg: PropTypes.bool,
  buttonText: PropTypes.string,
  cardHeader: PropTypes.element,
  customAsterisk: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  customCardWidth: PropTypes.string,
  dataTestId: PropTypes.string,
  enrollmentContent: PropTypes.element,
  onButtonClick: PropTypes.func,
  pageHeader: PropTypes.string,
  showSuccessPageView: PropTypes.bool,
  successContent: PropTypes.element,
};

PageContentCard.defaultProps = {
  backgroundImg: false,
  buttonText: null,
  cardHeader: null,
  customAsterisk: null,
  customCardWidth: null,
  dataTestId: '',
  enrollmentContent: null,
  onButtonClick: () => {},
  pageHeader: null,
  showSuccessPageView: null,
  successContent: null,
};

export default PageContentCard;
